import { faCalendarAlt, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { SedanIcon } from '../../components/vehicleIcons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import tw from 'twin.macro';
import { SCREENS } from '../../components/responsive';

import JeepImg from '../../../assets/images/jeep.png';
import { getBrand } from '../../constants/brands';

const AboutUsContainer = styled.div`
  ${tw`
    w-full
    flex
    flex-col
    items-center
    justify-center
    pt-12
    pb-12
    pr-7
    pl-7
    md:pl-0
    md:pr-0
    bg-white
  `};
`;

const ContentWrapper = styled.div`
  ${tw`
    w-full
    max-w-screen-2xl
    flex
    flex-wrap
    items-center
    justify-center
  `};
`;

const CarContainer = styled.div`
  width: auto;
  height: 15em;
  margin-left: 0;

  img {
    width: auto;
    height: 100%;
  }

  @media (min-width: ${SCREENS.md}) {
    height: 28em;
    /* Bleed left only when there is room; negative margin overflows mobile layout. */
    margin-left: -50px;
  }

  @media (min-width: ${SCREENS.lg}) {
    height: 30em;
  }

  @media (min-width: ${SCREENS['2xl']}) {
    height: 35em;
    margin-left: 0;
  }
`;

const InfoContainer = styled.div`
  ${tw`
    md:w-1/2
    flex
    flex-col
    md:ml-6
    2xl:ml-16
  `};
`;

const Title = styled.h2`
  ${tw`
    text-black
    text-2xl
    md:text-5xl
    font-extrabold
    md:font-black
    md:leading-normal
  `};
`;

const InfoText = styled.p`
  ${tw`
    md:max-w-2xl
    text-sm
    md:text-base
    text-text-secondary
    font-normal
    mt-4
    leading-relaxed
  `};
`;

const StepsSection = styled.div`
  ${tw`
    w-full
    mt-16
    md:mt-24
    flex
    flex-col
    items-center
  `};
`;

const StepsTitle = styled.h3`
  ${tw`
    text-2xl
    md:text-4xl
    text-black
    font-extrabold
    mb-10
  `};
`;

const StepsContainer = styled.div`
  ${tw`
    flex
    justify-evenly
    flex-wrap
    w-full
    max-w-screen-xl
  `};
`;

const StepContainer = styled.div`
  ${tw`
    flex
    flex-col
    md:w-96
    items-center
    m-5
  `};
`;

const Step = styled.div`
  box-shadow: 0 1.3px 12px -3px rgba(0, 0, 0, 0.2);
  ${tw`
    flex
    rounded-modal
    items-center
    justify-center
    p-6
    bg-bg-secondary
  `};
`;

const StepTitle = styled.h4`
  ${tw`
    text-black
    text-lg
    font-bold
    mt-4
  `};
`;

const StepDescription = styled.p`
  ${tw`
    w-10/12
    text-xs
    md:text-sm
    text-center
    text-text-secondary
    mt-2
  `};
`;

const StepIcon = styled.span`
  ${tw`
    text-[var(--color-black)]
    text-3xl
  `};
`;

export function AboutUs() {
  return (
    <AboutUsContainer>
      <ContentWrapper>
        <CarContainer>
          <img src={JeepImg} />
        </CarContainer>
        <InfoContainer>
          <Title>Feel The Best Experience With Our Rental Deals</Title>
          <AboutDescriptionText />
        </InfoContainer>
      </ContentWrapper>

      <StepsSection>
        <StepsTitle>How It Works</StepsTitle>
        <StepsContainer>
          <StepContainer>
            <Step>
              <StepIcon>
                <FontAwesomeIcon icon={faMapMarkedAlt} />
              </StepIcon>
            </Step>
            <StepTitle>Choose Location</StepTitle>
            <StepDescription>
              Find the nearest premium cars and book your car in the Bay Area.
            </StepDescription>
          </StepContainer>
          <StepContainer>
            <Step>
              <StepIcon>
                <FontAwesomeIcon icon={faCalendarAlt} />
              </StepIcon>
            </Step>
            <StepTitle>Pick-Up Date</StepTitle>
            <StepDescription>
              Pickup the Best Date to rent a car that fits your schedule.
            </StepDescription>
          </StepContainer>
          <StepContainer>
            <Step>
              <StepIcon>
                <SedanIcon size={32} color="var(--color-black)" />
              </StepIcon>
            </Step>
            <StepTitle>Book Your Car</StepTitle>
            <StepDescription>Book your nice car with ease in one single click.</StepDescription>
          </StepContainer>
        </StepsContainer>
      </StepsSection>
    </AboutUsContainer>
  );
}

function AboutDescriptionText() {
  return <InfoText>{getBrand().copy.about}</InfoText>;
}
